
import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import logo from '../../Assest/g1.jpg';
import classes from "./Wpp.module.css"
import Fade from "react-reveal/Fade"

export default function Wpp() {
    return (
        // <div className="App">
        //     <FloatingWhatsApp
        //         phoneNumber="+918446122201"
        //         accountName="EshikaTech Pvt Ltd"
        //         avatar={logo}
        //         chatMessage="Please feel free to ask your tools and engineering related questions, and I'll provide detailed responses here."
        //         allowEsc
        //         allowClickAway
        //         notification
        //         notificationSound
        //     />
        // </div>

 <div className={classes.container}>
    <Fade left>
           <img
                    src={logo}
                    alt="WhatsApp Icon"
                    className={classes.whatsappIcon2}
                />
                <br></br>
            <a 
                href="https://wa.me/+917620582520" 
                target="_blank" 
                rel="noopener noreferrer"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp Icon"
                    className={classes.whatsappIcon}
                />
            </a>
          
            </Fade>
        </div>
    );
}